import { IonToast } from '@ionic/react';
import { useUiStore } from '@/store/ui.store';

/** Renders auto-expiring toasts from the UI store. */
export default function ToastHost() {
  const toasts = useUiStore((s) => s.toasts);
  const [first] = toasts;
  if (!first) return null;
  return (
    <IonToast
      isOpen
      message={first.message}
      color={first.color}
      position="top"
      duration={3500}
      onDidDismiss={() => useUiStore.getState().dismiss(first.id)}
    />
  );
}
